import React from "react";
import styles from "./Row.module.sass";
import moment from "moment";

const Row = ({ data }) => {
  const formatDate = (date) => {
    const now = moment();
    const createdAt = moment(date);

    if (createdAt.isSame(now, "day")) {
      return "Today";
    } else if (createdAt.isSame(now.subtract(1, "day"), "day")) {
      return "Yesterday";
    } else {
      return createdAt.format("DD MMM YYYY");
    }
  };
  return (
    <div className={styles.row}>
      {/* <div className={styles.col}>{data.id}</div> */}
      <div className={styles.col}>{data.sync_type}</div>
      <div className={styles.col}>-</div>
      <div className={styles.col}>{data.employee.full_name}</div>
      <div className={styles.col}>{formatDate(data.created_at)}</div>
      <div className={styles.col}>{data.status}</div>

    </div>
  );
};

export default Row;
